/* UploadFX: only load + play product-gallery videos while they're actually visible.
   Videos are rendered with class="ufx-lazy-video", preload="none" and NO autoplay,
   so nothing downloads until it scrolls/switches into view. */
(function () {
  if (window.__ufxLazyVideoInit) return;
  window.__ufxLazyVideoInit = true;

  if (!('IntersectionObserver' in window)) {
    // Fallback: just play them (old browsers) so videos still work.
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('video.ufx-lazy-video').forEach(function (v) {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      });
    });
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting && e.intersectionRatio >= 0.5) {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      } else if (!v.paused) {
        v.pause();
      }
    });
  }, { threshold: [0, 0.5, 1] });

  function scan() {
    document.querySelectorAll('video.ufx-lazy-video:not([data-ufx-obs])').forEach(function (v) {
      v.setAttribute('data-ufx-obs', '1');
      io.observe(v);
    });
  }

  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);

  // Re-scan when the gallery re-renders (e.g. variant switch), debounced.
  var pending = false;
  var mo = new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; scan(); });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
